// extracted by mini-css-extract-plugin
export default {"products":"hC-z","card":"iC-z","oosMessaging":"jC-z"};